/**
 * Consent management for AlphaSignal.
 * GDPR / ePrivacy requires explicit consent before firing analytics
 * for EU/EEA users. This module is the single source of truth for
 * whether tracking is permitted.
 */

const CONSENT_KEY = 'alphasignal-analytics-consent';

export type ConsentState = 'granted' | 'denied' | 'pending';

export function getConsentState(): ConsentState {
  try {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (stored === 'granted') return 'granted';
    if (stored === 'denied') return 'denied';
    return 'pending';
  } catch {
    return 'pending';
  }
}

export function grantConsent(): void {
  try {
    localStorage.setItem(CONSENT_KEY, 'granted');
  } catch { /* noop */ }
}

export function denyConsent(): void {
  try {
    localStorage.setItem(CONSENT_KEY, 'denied');
  } catch { /* noop */ }
}

export function hasAnalyticsConsent(): boolean {
  return getConsentState() === 'granted';
}
